import { types, actions } from './actions'

const initialState: AffiliationState = {}

type SupportedActions = ActionsUnion<typeof actions>

// eslint-disable-next-line default-param-last
export const reducer = (state: AffiliationState = initialState, action: SupportedActions): AffiliationState => {
    switch (action.type) {
        case types.ASSIGN_AFFILIATION_SETTINGS:
            const result = {
                ...state,
                instanceSettings: action.payload as AffiliationSettingsDto,
            }
            return result
        case types.POPULATE_AFFILIATION_DATA:
            return {
                ...state,
                data: action.payload as AffiliationDataRecord[],
            }
    }
    return state
}
